import { render, staticRenderFns } from "./FlmAdditionalDocuments.vue?vue&type=template&id=40642d0f"
import script from "./FlmAdditionalDocuments.vue?vue&type=script&lang=ts"
export * from "./FlmAdditionalDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports